import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "./modules/auth/store";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("./pages/home.vue"),
    meta: {
      public: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./pages/login.vue"),
    meta: {
      public: true,
    },
  },
  {
    path: "/oauth2/redirect",
    name: "oauth2-redirect",
    component: () => import("./pages/oauth2-redirect.vue"),
    meta: {
      public: true,
    },
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("./pages/contact.vue"),
    meta: {
      public: true,
    },
  },
  {
    path: "/requests/:id",
    name: "request",
    component: () => import("./pages/request.vue"),
  },
  {
    path: "/checkout/success",
    name: "checkout-success",
    component: () => import("./pages/checkout/success.vue"),
  },
  {
    path: "/checkout/cancel",
    name: "checkout-cancel",
    component: () => import("./pages/checkout/cancel.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("./pages/not-found.vue"),
    meta: {
      public: true,
    },
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    // Delay scroll to wait for route transition (200ms leave + enter)
    return new Promise((resolve) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition);
        } else if (to.hash) {
          resolve({ el: to.hash, behavior: "smooth", top: 80 });
        } else {
          resolve({ top: 0, behavior: "smooth" });
        }
      }, 250);
    });
  },
});

router.beforeEach(async (to, _from, next) => {
  if (to.meta.public) {
    next();
    return;
  }

  const { refreshUser, $state } = useAuthStore();

  try {
    if (!$state.user) {
      await refreshUser();
    }
  } catch (err) {
    console.error(err);
    next({ path: "/login" });
  }

  next();
});
